export default __webpack_public_path__ + "static/media/energoobecpecch.06a2b0d9.pdf";